class CollectionPage extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-filter-drawer]');
    this.openButton = this.querySelector('[data-filter-open]');
    this.closeButtons = this.querySelectorAll('[data-filter-close]');
    this.loadMore = this.querySelector('[data-load-more]');
    this.grid = this.querySelector('[data-collection-grid]');

    this.openButton?.addEventListener('click', () => this.dialog?.showModal());
    this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.dialog?.close()));
    this.loadMore?.addEventListener('click', (event) => {
      event.preventDefault();
      this.fetchNextPage();
    });

    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
  }

  async fetchNextPage() {
    const button = this.loadMore;
    const url = button?.dataset.url;
    if (!url || !this.grid || button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Failed to load');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = doc.querySelector('[data-collection-grid]');
      const nextButton = doc.querySelector('[data-load-more]');
      const nextProgress = doc.querySelector('[data-collection-progress]');
      const items = nextGrid ? [...nextGrid.querySelectorAll('[data-collection-item]')] : [];
      items.forEach((item) => this.grid.append(item));
      if (items.length) {
        window.Theme?.initReveal?.();
        items[0].querySelector('a[href]')?.focus({ preventScroll: true });
      }
      const progress = this.querySelector('[data-collection-progress]');
      if (progress && nextProgress) progress.replaceWith(nextProgress);
      if (nextButton?.dataset.url) {
        button.dataset.url = nextButton.dataset.url;
        button.href = nextButton.getAttribute('href') || button.href;
      } else {
        button.hidden = true;
      }
    } catch {
      window.location.href = button.href;
    } finally {
      button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('collection-page')) customElements.define('collection-page', CollectionPage);
